module.exports = __webpack_public_path__ + "media/images/flags/IR-91a1ac496e3eb3dccca35739565b9a2a.svg";